import { Observable } from 'rxjs/Observable';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from "ngx-cookie-service";
import { tap } from "rxjs/operators";
import { Router } from "@angular/router";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private cookieService: CookieService,
    private router: Router,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let token = '';

    if (window.location.pathname.includes('/client/')) {
      token = this.cookieService.getAll()?.clientToken;
    } else {
      token = this.cookieService.getAll()?.adminToken;
    }

    let headers = req.headers
      .set('Authorization', `Bearer ${token}`);

    const request = req.clone({ headers });
    return next.handle(request).pipe( tap(() => {},
      (err: any) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status !== 401) {
            return;
          }
          if (err?.error['app'] === 'client') {
            this.router.navigate(['client/auth/login']);
          } else {
            this.router.navigate(['auth/login']);
          }
        }
      }));
  }
}
